import { AxiosResponse, AxiosError } from "axios";
import privateInstance from "./privateClient";
import { SessionManager } from "../services/storage/sessionManager";
import { isOfficeContext } from "../utils/context";
import { SESSION_KEY } from "../services/storage/storage.data";

/* global AbortController, console */

let globalController: AbortController | null = null;

const setupPrivateClient: () => void = () => {
  const sessionManager = SessionManager.getInstance();

  privateInstance.interceptors.request.use(
    async (config) => {
      if (!globalController || globalController.signal.aborted) {
        globalController = new AbortController();
      }
      config.signal = globalController.signal;

      if (isOfficeContext()) {
        try {
          const session = await sessionManager.getSession();
          if (session) {
            config.headers["Cookie"] =
              `${SESSION_KEY}=${JSON.stringify(session)}`;
          }
        } catch (error) {
          console.error("Error getting session for API call:", error);
        }
      }

      return config;
    },
    (error) => Promise.reject(error),
  );

  privateInstance.interceptors.response.use(
    (response: AxiosResponse) => response,
    async (error: AxiosError) => {
      if (error.response && error.response.status === 401) {
        if (globalController) {
          globalController.abort();
          globalController = null;
        }

        await sessionManager.clearSession();

        return Promise.reject("Unauthorized");
      }

      return Promise.reject(error);
    },
  );
};

export default setupPrivateClient;
